import { render, staticRenderFns } from "./DeletedClientList.vue?vue&type=template&id=1cbb3b4c"
import script from "./DeletedClientList.vue?vue&type=script&lang=js"
export * from "./DeletedClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports